var React = require('react');

function TvgLogoWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M30.23 2.44c.33.14.56.4.56.84h4.5c.2-2.13-1.6-3.12-6.1-3.12-.9 0-1.9.07-2.86.27H19.8l-3.6 5.3-.88-5.3H.7l-.56 2.1h3.92L2.46 8.7h4l1.6-6.18h3.5l1.78 6.18h4.2l4.67-5.77c-.3.48-.53 1.03-.7 1.67-1 3.8 2.68 4.38 5.5 4.38 2.3 0 3.67-.3 4.9-1.04l.26.76h1.72l1.2-4.7h-5.7l-.47 1.86h1.65c-.45.62-1.2 1.03-2.5 1.03-2 0-2.78-.8-2.38-2.38.43-1.66 1.64-2.32 3.27-2.32.52 0 .96.06 1.3.2z"}));
}

TvgLogoWhite.defaultProps = {"width":"36","height":"9","viewBox":"0 0 36 9"};

module.exports = TvgLogoWhite;

TvgLogoWhite.default = TvgLogoWhite;
